import { useAtomValue, useSetAtom } from "jotai";
import { curCourse, curSessionIdAtom } from "../../../store";
import { useSession } from "../../../Utils/useSession";
import {
    getCourseList,
    OppositeUserType,
    useRequest
} from "../../../polyfills";
import { CourseListItem } from "../../../types";
import { getLastItem } from "../../../Utils/common";
import _ from "underscore";
import { useEffect } from "react";

export function useLoadCourse({
    courseNo,
    courseSeq
}: {
    courseNo?: string;
    courseSeq?: string;
}) {
    const curSessionId = useAtomValue(curSessionIdAtom);
    const { session } = useSession(curSessionId || "");
    const setCourse = useSetAtom(curCourse);

    const [data, { loading }] = useRequest<CourseListItem[] | undefined>(
        async () => {
            if (!session) return undefined;

            const lastMsg = getLastItem(session.chatMessages || []);

            try {
                const chatMember = session.chatConferees.find(
                    item => item.type === OppositeUserType
                );

                const courseList = await getCourseList(
                    chatMember?.no || "",
                    chatMember?.type || ""
                );

                const findCourse = _.find(courseList, {
                    courseNo: courseNo ? courseNo : lastMsg?.courseNo,
                    courseSeq: courseSeq ? courseSeq : lastMsg?.courseSeq
                });

                // 优先选择最后一个聊天的课程, 其次选择课程列表的第一个课程
                if (findCourse) {
                    setCourse(findCourse);
                } else if (courseList[0]) {
                    setCourse(courseList[0]);
                }

                return courseList;
            } catch (e) {
                return undefined;
            }
        }
    );

    // 离开时课程清空
    useEffect(() => {
        return () => setCourse(undefined);
    }, []);

    return { loading, data };
}
